var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiivii(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 43,
    height: 35,
    viewBox: "0 0 43 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.372,0H25.628A3.372,3.372,0,0,1,29,3.372v16.86A3.372,3.372,0,0,1,25.628,23.6H3.372A3.372,3.372,0,0,1,0,20.233V3.372A3.372,3.372,0,0,1,3.372,0Z",
    transform: "translate(240 619.698)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-233 -614)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5,0H38a5,5,0,0,1,5,5V30a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0Z",
    transform: "translate(233 614)",
    fill: "#f8f8f8"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(242.697 619.698)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.802,
    cy: 11.802,
    r: 11.802,
    fill: "#e30613"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8,18.175l-4.66,1.661a6,6,0,0,1-1.57.141,3.375,3.375,0,0,1-2.316-.823,3.158,3.158,0,0,1-.8-2.367V10.057a.25.25,0,0,0-.283-.283H7.7a.539.539,0,0,1-.386-.18.626.626,0,0,1-.18-.463V7.51a.627.627,0,0,1,.18-.463.541.541,0,0,1,.386-.18h7.874a.6.6,0,0,1,.437.18.628.628,0,0,1,.18.463V9.131a.626.626,0,0,1-.18.463.6.6,0,0,1-.437.18h-2.83a.341.341,0,0,0-.206.077.244.244,0,0,0-.1.206l.026,6.189a1.16,1.16,0,0,0,.36,1.016.946.946,0,0,0,.823.116l4.313-1.558a.875.875,0,0,1,.489-.1.3.3,0,0,1,.283.232l.592,1.647c.034.086.058.3-.089.383Z",
    fill: "#a61a17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.935,16.883l-4.66,1.661a6,6,0,0,1-1.57.141,3.375,3.375,0,0,1-2.316-.823,3.158,3.158,0,0,1-.8-2.367V8.765a.25.25,0,0,0-.283-.283H6.842a.539.539,0,0,1-.386-.18.626.626,0,0,1-.18-.463V6.218a.627.627,0,0,1,.18-.463.541.541,0,0,1,.386-.18h7.873a.6.6,0,0,1,.437.18.628.628,0,0,1,.18.463V7.839a.626.626,0,0,1-.18.463.6.6,0,0,1-.437.18h-2.83a.341.341,0,0,0-.206.077.244.244,0,0,0-.1.206l.026,6.189a1.16,1.16,0,0,0,.36,1.016.946.946,0,0,0,.823.116L17.1,14.529a.875.875,0,0,1,.489-.1.3.3,0,0,1,.283.232l.592,1.647c.034.086.058.3-.089.383Z",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiivii);
export default __webpack_public_path__ + "static/media/tiivii.013461fe7ffc4bcda2d6d4448d5bbb3b.svg";
export { ForwardRef as ReactComponent };